/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*

*/

import React from 'react';
import { View, ScrollView, Dimensions } from 'react-native';
import { useSelector } from 'react-redux';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Toast from 'react-native-toast-message';
import useApi from '@/hooks/useApi';
import { MsB2b } from '@api/ms-b2b';

import ModalFull from '@components/modal/ModalFull';
import SociollaText from '@components/sociolla/SociollaText';
import Input from '@components/form/Input';
import Button from '@components/form/Button';
import CustomerSearch from '@components/form/search/CustomerSearch';
import OutletSearch from '@components/form/search/OutletSearch';
import { SociollaBrandSearch } from '@components/sociolla/form';
import {
  Wrapper,
  FormWrapper,
  FormGroup,
  ButtonSticky,
} from '@components/screen/Layout';

import Colors from '@global/colors';
import { isWeb, isAndroid, isNative, isMobileWeb } from '@global/screens';

const dimension = Dimensions.get('screen');
const heightContainer = isWeb
  ? dimension.height - 200
  : isMobileWeb
  ? dimension.height - 55
  : 0;

const SelectCustomerBrandBudget = ({
  testID = 'select-customer-brand-budget-modal',
  show,
  onChange, // on change callback
  onClose = () => {},
  customerFilter = {},
  customerType = 'GT',
}) => {
  const showModal = show ? true : false; // show or hide add product popup
  const isSubdis = customerType.toLowerCase() == 'subdistributor';
  const isMT = customerType.toLowerCase() == 'mt';

  const { request: fetchBudgetSuggestion } = useApi(
    MsB2b.getSkpInternalBudgetSuggestion,
  );

  const FormValidationSchema = Yup.object().shape({
    customer: Yup.object().required('Customer is required.'),
    brand: Yup.object().required('To Quantity is required.'),
    budget_sample: Yup.number().required('Budget Sample is required.'),
    ...(isSubdis && {
      outlet: Yup.object().nullable().required('Outlet is required.'),
    }),
  });

  const auth = useSelector((state) => state.auth);
  const filter = {
    status: 'approved',
    cerebro_id: { $exists: true },
    is_active: true,
    ...customerFilter,
  };

  if (
    [
      'regional_manager',
      'regional_support',
      'key_account_manager',
      'group_key_account_manager',
    ].includes(auth.user.role.code)
  ) {
    filter['sales_team.id'] = {
      $in: auth.user.sales_team.map((x) => x.id),
    };
  }

  return (
    <ModalFull
      testID={testID}
      show={showModal}
      title={'Add Customer And Brand'}
      onClose={() => {
        onClose();
      }}
      width={isWeb ? '30%' : '100%'}>
      <Formik
        initialValues={{
          customer: '',
          brand: '',
          budget_sample: '',
        }}
        validationSchema={FormValidationSchema}
        onSubmit={(values, { setErrors }) => {
          const customer = {
            id: values?.customer?._id,
            name: values?.customer?.name,
            code: values?.customer?.customer_code,
            is_pkp: values?.customer?.is_pkp || false,
            is_npwp_document_exists: values?.customer?.documents?.some(
              (doc) => doc.type === 'npwp',
            ),
            npwp_no: values?.customer?.vat || '',
            wht: values?.customer?.wht || '',
            market_type: values.customer?.market_type,
            key_account_manager: values.customer?.key_account_manager,
            account_manager: values.customer?.account_manager,
          };

          if (!customer?.wht) {
            setErrors({
              customer: 'Customer WHT is empty',
            });
            return;
          }
          if (typeof customer?.is_pkp != 'boolean') {
            setErrors({
              customer: 'Customer Taxable is not valid',
            });
            return;
          }

          const outlet = {
            id: values?.outlet?._id,
            name: values?.outlet?.name,
            code: values?.outlet?.code,
            business_type: values?.outlet?.business_type,
            sales_team: values?.outlet?.sales_team,
            is_pkp: values?.outlet?.tax_is_pkp,
            wht: values?.outlet?.tax_wht,
          };

          if (isSubdis && !outlet.id) {
            setErrors({
              outlet: 'Outlet is required.',
            });
            Toast.show({
              text1: 'Outlet is required.',
              type: 'error',
            });
            return;
          }

          if (outlet.id) {
            if (!outlet?.wht) {
              setErrors({
                outlet: 'Outlet WHT is empty',
              });
              return;
            }
            if (typeof outlet?.is_pkp != 'boolean') {
              setErrors({
                outlet: 'Outlet WHT is empty',
              });
              return;
            }
          }

          const brand = {
            id: values?.brand?.id,
            name: values?.brand?.name,
          };
          if (brand.id == 'all') {
            delete brand.id;
          }
          const item = {
            customer,
            outlet,
            brand,
            budget_sample: Math.round(Number(values.budget_sample)),
          };
          onChange(item);
          onClose(); // close add product popup
        }}>
        {({
          handleChange,
          setFieldValue,
          handleSubmit,
          errors,
          touched,
          values,
        }) => (
          <>
            <Wrapper fullWidth style={{ paddingBottom: isWeb ? 0 : 55 }}>
              <FormWrapper>
                <ScrollView
                  style={
                    isWeb
                      ? { maxHeight: heightContainer }
                      : isMobileWeb
                      ? { height: heightContainer }
                      : {}
                  }>
                  <View
                    style={{
                      width: '100%',
                      paddingHorizontal: 10,
                      paddingVertical: 15,
                      marginBottom: isNative
                        ? isAndroid
                          ? 140
                          : 70
                        : isMobileWeb
                        ? 55
                        : 0,
                    }}>
                    <View
                      style={{
                        width: '100%',
                        flexDirection: isWeb ? 'row' : 'column',
                        ...(isWeb ? { justifyContent: 'space-between' } : {}),
                      }}>
                      <View style={{ width: '100%' }}>
                        <FormGroup>
                          <CustomerSearch
                            fields="_id name customer_code is_pkp documents vat wht market_type key_account_manager account_manager"
                            value={values.customer}
                            labelKey="display_label"
                            isRequired={true}
                            hasError={
                              errors.customer && touched.customer
                                ? errors.customer
                                : null
                            }
                            customFilter={filter}
                            onChange={async (value) => {
                              setFieldValue('customer', value);
                              setFieldValue('outlet', null);
                              if (isMT && value?._id && values.brand?.id) {
                                const res = await fetchBudgetSuggestion({
                                  params: {
                                    customer_id: value._id,
                                    brand_id: values.brand.id,
                                  },
                                });
                                if (res?.data?.data?.budget_sample != null) {
                                  setFieldValue(
                                    'budget_sample',
                                    String(res.data.data.budget_sample),
                                  );
                                }
                              }
                            }}
                            searchWithCode={true}
                          />
                        </FormGroup>
                        {isSubdis && (
                          <FormGroup>
                            <OutletSearch
                              value={values.outlet}
                              isRequired={true}
                              hasError={
                                errors.outlet && touched.outlet
                                  ? errors.outlet
                                  : null
                              }
                              customFilter={{
                                'customer.id':
                                  values.customer?._id || values.customer?.id,
                              }}
                              onChange={async (val) => {
                                setFieldValue('outlet', val);
                              }}
                              editable={!!values.customer}
                            />
                          </FormGroup>
                        )}
                        <FormGroup>
                          <SociollaBrandSearch
                            name="brands"
                            isRequired
                            allBrand={false}
                            onChange={async (value) => {
                              setFieldValue('brand', value);
                              if (isMT && value?.id && values.customer?._id) {
                                const res = await fetchBudgetSuggestion({
                                  params: {
                                    customer_id: values.customer._id,
                                    brand_id: value.id,
                                  },
                                });
                                if (res?.data?.data?.budget_sample != null) {
                                  setFieldValue(
                                    'budget_sample',
                                    String(res.data.data.budget_sample),
                                  );
                                }
                              }
                            }}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Input
                            label="Budget Sample"
                            placeholder="Budget Sample"
                            value={values.budget_sample}
                            isRequired
                            hasError={
                              errors.budget_sample && touched.budget_sample
                                ? errors.budget_sample
                                : null
                            }
                            onChangeText={(value) => {
                              setFieldValue('budget_sample', value);
                            }}
                            keyboardType="numeric"
                            isNumeric={true}
                          />
                        </FormGroup>
                      </View>
                    </View>
                    {isWeb && (
                      <View
                        style={{
                          width: '100%',
                          paddingTop: 20,
                          paddingBottom: 20,
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'flex-end',
                        }}>
                        <Button
                          rounded
                          buttonStyle={{
                            width: 150,
                            backgroundColor: Colors.white,
                            marginRight: 10,
                          }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{
                                fontSize: 14,
                                letterSpacing: 0.5,
                                color: Colors.black,
                              }}>
                              Cancel
                            </SociollaText>
                          }
                          onPress={onClose}
                        />
                        <Button
                          rounded
                          buttonStyle={{ width: 150 }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{
                                fontSize: 14,
                                letterSpacing: 0.5,
                                color: Colors.white,
                              }}>
                              Save
                            </SociollaText>
                          }
                          onPress={() => {
                            if (isSubdis && !values.outlet) {
                              Toast.show({
                                text1: 'Outlet is required.',
                                type: 'error',
                              });
                            }
                            handleSubmit();
                          }}
                        />
                      </View>
                    )}
                  </View>
                </ScrollView>
                {!isWeb && (
                  <ButtonSticky
                    show
                    customHost="modal-sticky-button"
                    buttons={[
                      {
                        title: 'Cancel',
                        type: 'default',
                        onPress: () => onClose(),
                      },
                      {
                        title: 'Save',
                        type: 'primary',
                        onPress: () => {
                          if (isSubdis && !values.outlet) {
                            Toast.show({
                              text1: 'Outlet is required.',
                              type: 'error',
                            });
                          }
                          handleSubmit();
                        },
                      },
                    ]}
                  />
                )}
              </FormWrapper>
            </Wrapper>
          </>
        )}
      </Formik>
    </ModalFull>
  );
};

export default SelectCustomerBrandBudget;
